import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useBrandAccountAiEnabledQueryKey } from './useBrandAccountAiEnabledQueryKey'

const document = graphql(`
  query UseBrandAccountAiEnabledQuery_Main($brandAccountId: ID!) {
    brandAccount(brandAccountId: $brandAccountId) {
      id
      aiEnabled
    }
  }
`)

export const useBrandAccountAiEnabledQuery = (
  brandAccountId: string | undefined,
) => {
  const queryKey = useBrandAccountAiEnabledQueryKey(brandAccountId)
  const graphQLRequest = useGraphQLRequest()

  return useQuery({
    enabled: exists(brandAccountId),
    queryFn: async () =>
      await graphQLRequest({
        document,
        variables: { brandAccountId: brandAccountId! },
      }),
    queryKey,
    staleTime: 60_000,
  })
}
